import React from 'react'

export const Header = () =>
  <div className='sidebar-header'>
    <p>Podeli sa prijateljima</p>
  </div>
